"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var voyageMissionData_sidecar_1 = require("./voyageMissionData-sidecar");
function create(type) {
    var data = voyageMissionData_sidecar_1.voyageMissionData.find(type);
    var obj = {
        data: data,
        genMission: data.genMission(),
        waves: data.genWaves(),
        waveIdx: 0,
        waveTimer: 0,
    };
    return obj;
}
exports.create = create;
